function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.98816 1.98816C1.67559 2.30072 1.5 2.72464 1.5 3.16667V4C1.5 10.9033 7.09667 16.5 14 16.5H14.8333C15.2754 16.5 15.6993 16.3244 16.0118 16.0118C16.3244 15.6993 16.5 15.2754 16.5 14.8333V12.1008C16.5 11.9259 16.445 11.7553 16.3427 11.6134C16.2404 11.4714 16.096 11.3653 15.93 11.31L12.1858 10.0617C11.9956 9.99841 11.7888 10.0059 11.6036 10.0827C11.4184 10.1596 11.2671 10.3006 11.1775 10.48L10.2358 12.3608C8.19538 11.4389 6.5611 9.80462 5.63917 7.76417L7.52 6.8225C7.69938 6.73288 7.84042 6.58158 7.91726 6.39637C7.9941 6.21116 8.00158 6.00445 7.93833 5.81417L6.69 2.07C6.63475 1.90413 6.52874 1.75984 6.38696 1.65754C6.24519 1.55525 6.07483 1.50013 5.9 1.5H3.16667C2.72464 1.5 2.30072 1.67559 1.98816 1.98816Z",
  stroke: "#9CA3AF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.eba59523.svg";
export { ForwardRef as ReactComponent };